import { Link } from "react-router-dom";

export const COLUMNS1 = [
   


    {
        Header: "Customer Id",
        Footer: "Customer Id",
        accessor: "customerId",
    },

 

  
    {
        Header: "Earned Value",
        Footer: "Earned Value",
        accessor: "earnedValue",
    },
    {
        Header: "Available Value",
        Footer: "Available Value",
        accessor: "availableValue",
    },
    {
        Header: "Redeem Value",
        Footer: "Redeem Value",
        accessor: "redeemValue",
    },
    {
        Header: "Expired Value",
        Footer: "Expired Value",
        accessor: "expiredValue",
    },
    // {
    //     Header: "Update Date",
    //     Footer: "Update Date",
    //     accessor: "updatedDate",
    // },

    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: ({ value }) => (
            <Link
                to={{
                    pathname: `/customer-view/${value}`,
                    state: { customerCode: value },
                }}
            >
                <i className="fa-solid fa-eye"></i> View Details
            </Link>
        ),
    },
];
